import { useCallback, useRef } from 'react';
import { usePopup } from 'scbk-shared-module/modules/GlobalComponents';
import { EdocViewParameter } from '../types';

export const useEdocView = () => {
  const popup = usePopup('edocViewer');

  const viewParamsRef = useRef<EdocViewParameter>({} as EdocViewParameter);

  // 전자문서 뷰어
  const open = useCallback(
    async (props: EdocViewParameter) => {
      popup.setTrigger();
      popup.open();
      viewParamsRef.current = props;
    },
    [popup],
  );

  return {
    open,
    isOpen: popup.isOpen,
    close: popup.close,
    setOpen: popup.setOpen,
    params: viewParamsRef.current,
  };
};
